import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { Icon, Input } from '../../../../../../components/UI'
import ErrorMessageWithExclamation from '../../../../../../components/UI/ErrorMessageWithExclamation'
import DropDown from '../../../../../../components/Input/DropDown'

import { arrayFromNumber } from '../../../../../../helpers'

const MyQuizTemplateCreateTask = ({ index, onDelete }) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext()

  const questionErrors = errors.questions?.[index]

  return (
    <div className="w-full flex flex-col items-start gap-y-[20px] p-[32px] rounded-[10px] border-[#F79009] border-[1px]">
      <div className="w-full flex items-center justify-between">
        <h2 className="text-sm font-bold text-primary-100">Question #{index + 1}</h2>

        <button type="button" onClick={() => onDelete(index)}>
          <Icon name="delete-bin-line" color="#F67443" className="w-[24px] h-[24px]" />
        </button>
      </div>

      <div className="w-full">
        <label
          htmlFor={`${index}-question`}
          className="mb-[6px] text-primary-100 text-sm font-medium"
        >
          What is the question?
        </label>

        <Input
          type="text"
          id={`${index}-question`}
          placeholder="Type the question"
          className="text-primary-100"
          {...register(`questions.${index}.question_text`)}
        />

        {questionErrors?.question_text && (
          <ErrorMessageWithExclamation text={questionErrors.question_text.message} />
        )}
      </div>

      <div className="w-full">
        <label
          htmlFor={`${index}-correct`}
          className="mb-[6px] text-primary-100 text-sm font-medium"
        >
          Correct Answer
        </label>

        <Controller
          control={control}
          name={`questions.${index}.correct_option`}
          render={({ field: { value, onChange } }) => {
            return (
              <DropDown
                placeholderClassName="!text-[#F6744388]"
                placeholder="Select the correct answer"
                menuItems={arrayFromNumber(4).map((value) => {
                  return {
                    label: value + 1,
                    value: value + 1,
                  }
                })}
                value={value}
                setValue={onChange}
              />
            )
          }}
        />

        {questionErrors?.correct_option && (
          <ErrorMessageWithExclamation text={questionErrors.correct_option.message} />
        )}
      </div>

      <div className="w-full">
        <span className="inline-block mb-[6px] text-primary-100 text-sm font-medium">Answers</span>

        <div className="w-full flex flex-col gap-y-[10px]">
          <div className="w-full">
            <Input
              type="text"
              id={`${index}-correct`}
              placeholder="Type the anwer"
              className="text-primary-100"
              {...register(`questions.${index}.option1`)}
            />

            {questionErrors?.option1 && (
              <ErrorMessageWithExclamation text={questionErrors.option1.message} />
            )}
          </div>

          <div className="w-full">
            <Input
              type="text"
              id={`${index}-correct`}
              placeholder="Type the anwer"
              className="text-primary-100"
              {...register(`questions.${index}.option2`)}
            />

            {questionErrors?.option2 && (
              <ErrorMessageWithExclamation text={questionErrors.option2.message} />
            )}
          </div>

          <div className="w-full">
            <Input
              type="text"
              id={`${index}-correct`}
              placeholder="Type the anwer"
              className="text-primary-100"
              {...register(`questions.${index}.option3`)}
            />

            {questionErrors?.option3 && (
              <ErrorMessageWithExclamation text={questionErrors.option3.message} />
            )}
          </div>

          <div className="w-full">
            <Input
              type="text"
              id={`${index}-correct`}
              placeholder="Type the anwer"
              className="text-primary-100"
              {...register(`questions.${index}.option4`)}
            />

            {questionErrors?.option4 && (
              <ErrorMessageWithExclamation text={questionErrors.option4.message} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MyQuizTemplateCreateTask
